export function getCultureCodeFromLocalStorage(): string | null {
	return localStorage.getItem('cultureCode');
}

export function setCultureCodeToLocalStorage(cultureCode: string): void {
	localStorage.setItem('cultureCode', cultureCode);
}
